import React, { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { motion } from "framer-motion";
const wordVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
};
const AnimatedText = ({ data }) => {
  const [currentText, setCurrentText] = useState("");
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [letterIndex, setLetterIndex] = useState(0);
  const phrases = data;
  useEffect(() => {
    if (!phrases || phrases.length === 0) return;

    if (letterIndex < phrases[phraseIndex].length) {
      const timeout = setTimeout(() => {
        setCurrentText((prev) => prev + phrases[phraseIndex][letterIndex]);
        setLetterIndex((prev) => prev + 1);
      }, 100);

    return () => clearTimeout(timeout);
    } else {
      const timeout = setTimeout(() => {
        setLetterIndex(0);
        setCurrentText("");
        setPhraseIndex((prev) => (prev + 1) % phrases.length);
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, [letterIndex]);

  return (
    <Box sx={{ textAlign: "center", margin: 0, padding: 0 }}>
      <Typography
        variant="h3"
        sx={{
          fontSize: {
            xs: "1.2rem",
            sm: "1.5rem",
            md: "2.4rem",
            lg: "1.7rem",
            xl: "2.5rem",
          },
          fontWeight: "600",
          lineHeight: "1.3",
          fontFamily: "Poppins, sans-serif",
          margin: 0,
          padding: 0,
          display: "inline-block",
          verticalAlign: "middle",
          whiteSpace: "normal", // ✅ Allows natural word wrapping
          wordBreak: "break-word", // ✅ Moves whole words to the next line
        }}
      >
        {currentText.split(" ").map((word, index) => (
          <motion.span
            key={index}
            variants={wordVariants}
            initial="hidden"
            animate="visible"
            style={{
              display: "inline-block",
              whiteSpace: "nowrap", // ✅ Ensures words stay whole
              marginRight: "6px", // ✅ Adds spacing between words
            }}
          >
            {word}
          </motion.span>
        ))}
      </Typography>
    </Box>
  );
};

export default AnimatedText;
